<template>

	<div>


		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="search_data.page"
		 :page-sizes="[10, 20, 30, 40 ,50]" :page-size="search_data.limit" layout="total, sizes, prev, pager, next, jumper"
		 :total="result_data.count">
		</el-pagination>


	</div>
</template>
<script>
	var _this;
	export default {

		created() {

			_this = this;

		},
		// 接受父组件传的值
		props: {
			search_data: {},
			result_data: {}
		},
		// 监听父组件传过来的值
		watch: {

			search_data(newData, oldData) {

				_this.search_data = newData;

			},

			result_data(newData, oldData) {

				_this.result_data = newData;

			}

		},
		data() {
			return {

			}
		},
		methods: {


			//下拉条（每页显示多少数据）变化
			handleSizeChange(val) {

				_this.search_data.limit = val;

				_this.$emit('pages_function', _this.search_data);

			},

			//页码变化
			handleCurrentChange(val) {

				_this.search_data.page = val;
				//初始化显示列表
				_this.$emit('pages_function', _this.search_data);


			},

		}
	}
</script>



// WEBPACK FOOTER //
// src/common/mine/pages.vue